//hooks
import useAcl from '@/hooks/user/useAcl';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Lib
import { POST_STATUS } from '@/lib/scheduler/postStatus';

import { DropDownFilter } from '@/components/base/DropdownFilter/DropdownFilter';
// Component
import Loader from '@/components/base/Loader';

export const statusOptions = [
    {
        name: 'scheduler:status.all',
        value: 'all'
    },
    ...Object.keys(POST_STATUS).map((statusKey) => {
        const status = POST_STATUS[statusKey];
        return {
            name: status.text,
            value: statusKey,
            color: status.color,
            permissions: status.permissions
        };
    })
];

const FeedHeaderFilter = ({
    isLoading = true,
    itemsNumber,
    activeFilter,
    setActiveFilter,
    changeStatusFilter = () => {
        /** */
    }
}) => {
    const { t } = useTranslation();
    const { hasAcl } = useAcl();

    return (
        <DropDownFilter
            size="full"
            classNameWrapper="manipulation-header z-10"
            currentFilter={activeFilter}
            filters={statusOptions.filter((status) => {
                if (status.permissions) {
                    if (hasAcl(status.permissions)) {
                        return status;
                    } else {
                        return;
                    }
                }

                return status;
            })}
            setFilter={(option) => {
                setActiveFilter(option);
                changeStatusFilter(option);
            }}
            buttonClassName="font-GBold text-xl"
            buttonContent={
                <span className="flex items-center space-x-1">
                    {activeFilter?.color ? (
                        <span
                            className="inline-block h-2.5 w-2.5 rounded-full"
                            style={{ backgroundColor: activeFilter.color }}
                        />
                    ) : null}
                    <span>{t(activeFilter?.name)}</span>
                    <span className="flex items-center">
                        ({isLoading ? <Loader className="h-3 w-3 text-icoBlue" /> : itemsNumber})
                    </span>
                </span>
            }
            position="left"
            className="text-base"
        />
    );
};

FeedHeaderFilter.propTypes = {
    isLoading: PropTypes.bool,
    itemsNumber: PropTypes.number,
    changeStatusFilter: PropTypes.func
};

export default FeedHeaderFilter;
